import startCase from 'lodash/startCase'
import { observer } from 'mobx-react-lite'
import PendingVisit from 'models/Provider/visits/PendingVisit'
import { Fragment, ReactNode } from 'react'
import { getServiceTypeLabel } from 'util/formatters'
import yesNo from 'util/yesNo'

const REFERRALS = ['serviceType', 'timeframe', 'notes', 'careCoordinatorNeeded']

const CUSTOM_LABELS = {
  timeframe: 'When',
  careCoordinatorNeeded: 'Care Coordinator',
}

const VALUE_TRANSFORMERS = {
  serviceType: getServiceTypeLabel,
  careCoordinatorNeeded: yesNo,
}

type ReferralsListProps = {
  visit: PendingVisit
  renderItem?: (props: { label: string; value: ReactNode }) => ReactNode
}

const ReferralsList = ({ visit, renderItem }: ReferralsListProps) => {
  return REFERRALS.map((name, i) => {
    const label = CUSTOM_LABELS[name] || startCase(name)
    const value = (VALUE_TRANSFORMERS[name] || startCase)(visit.referral[name])

    if (renderItem) {
      return <Fragment key={i}>{renderItem({ label, value })}</Fragment>
    }

    return (
      <div key={i}>
        <p className="typography-body font-medium pt-4">{label}</p>
        <p className="typography-small">{value}</p>
      </div>
    )
  })
}

export default observer(ReferralsList)
